import {ErrorMessage, FieldArray} from 'formik';
import React from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';

import {Btn, Icon, Spacer} from '../../../ui-toolkit/index';
import {Card, FormGroup} from '../../../ui-toolkit/indexExportV2';

import {unwrapNullableDataType} from '../../../ducks/formattersettingshelpers';
import {FormErrorMessage} from '../../../ui-toolkit/forms/form-features/FormErrorMessage';
import {useFormatterById} from '../../FormattersContext';
import {createInitialEntity} from '../../type-util.js';

/**
 * A component that renders a form field for editing a list of entities of a specific entity data type. The data type
 * provided to this component can be either `ArrayDataType` or a `NullableDataType` that wraps an `ArrayDataType>`.
 */
function ArrayEditor({formatter, entity, fieldName, entityType, t}) {
    const arrayDataType = unwrapNullableDataType(entityType);
    const subFormatter = useFormatterById(formatter.settings.entryFormatterId);
    const FieldFormatter = subFormatter;

    if (entity == null || entity === '') entity = [];

    return (
        <FieldArray
            name={fieldName}
            render={(arrayHelpers) => (
                <>
                    <ErrorMessage name={fieldName} component={FormErrorMessage} />
                    <Spacer.Stacked space="md">
                        {entity.map((child, ix) => (
                            <Card key={ix}>
                                <Card.Actions>
                                    <Btn color="danger" type="button" round onClick={() => arrayHelpers.remove(ix)}>
                                        <Icon type="sm" name="Close" />
                                    </Btn>
                                </Card.Actions>
                                <FormGroup>
                                    <FieldFormatter.Formatter
                                        entityType={arrayDataType.childDataType}
                                        formatter={subFormatter}
                                        entity={child}
                                        fieldName={fieldName + '[' + ix + ']'}
                                    />
                                </FormGroup>
                            </Card>
                        ))}
                    </Spacer.Stacked>

                    <ArrayBtnWrapper>
                        <Btn
                            type="button"
                            color="primary"
                            onClick={() => arrayHelpers.push(createInitialEntity(arrayDataType.childDataType))}>
                            <Icon name="add" />
                            {t('arrayEditor.addNew', {
                                typeName:
                                    arrayDataType.childDataType.menuLabel || arrayDataType.childDataType.dataTypeName,
                            })}
                        </Btn>
                    </ArrayBtnWrapper>
                </>
            )}
        />
    );
}

const ArrayBtnWrapper = styled.div`
    margin-bottom: var(--space-lg);
`;

export default withTranslation()(ArrayEditor);
